'use strict';

module.exports = {
	carouselControl: function () {
		$(document).on('slide.bs.carousel', '.carousel.slide', function (event) {
			const indicatorElements = $('.carousel-preview');
			let currentElement = indicatorElements.find('.carousel-preview-item')[event.from];
			let nextElement = indicatorElements.find('.carousel-preview-item')[event.to];

			$(currentElement).removeClass('active');
			$(nextElement).addClass('active');
		});
	}
};
